import { render, staticRenderFns } from "./LegalServiceModal.vue?vue&type=template&id=d67b3072&scoped=true"
import script from "./LegalServiceModal.vue?vue&type=script&lang=js"
export * from "./LegalServiceModal.vue?vue&type=script&lang=js"
import style0 from "./LegalServiceModal.vue?vue&type=style&index=0&id=d67b3072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67b3072",
  null
  
)

export default component.exports